import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import { VideoBlock } from "../../../Shared/components/ContentBlocks/VideoBlock/VideoBlockLayout";
import { ResponsivePicture } from "../../../Shared/components/Image";
import { classNamesConfig } from "../../../Shared/features/classnames";
import { slugify } from "../../../Shared/utils/string";
import { Block } from "./library/container";
export const RichTextBlock = (p)=>{
    const classNames = classNamesConfig().text;
    const innerClass = p.media != "none" && classNames.innerWithMedia ? classNames.innerWithMedia : classNames.inner;
    const media = p.media != "none" && p.media.media.kind == "image" ? /*#__PURE__*/ _jsx("div", {
        className: "image-block__wrapper",
        children: /*#__PURE__*/ _jsx("div", {
            className: `image-block__inner`,
            children: /*#__PURE__*/ _jsx("div", {
                className: `richtextt-block__visual ${p.media.display}`,
                children: /*#__PURE__*/ _jsx(ResponsivePicture, {
                    imgClassName: "image-block__image",
                    defaultImageUrl: p.media.media.imageUrlFallback,
                    cropsPerMedia: [
                        {
                            crops: [
                                {
                                    url: p.media.media.imageUrlSmall,
                                    width: 360
                                },
                                {
                                    url: p.media.media.imageUrl,
                                    width: 720
                                },
                                {
                                    url: p.media.media.imageUrlLarge,
                                    width: 1880
                                }
                            ]
                        }
                    ],
                    lazyload: true,
                    width: 360,
                    height: 300,
                    alt: p.media.media.imageAlt
                })
            })
        })
    }) : p.media != "none" && p.media.media.kind == "video" ? /*#__PURE__*/ _jsx("div", {
        className: "video-block__wrapper",
        children: /*#__PURE__*/ _jsx("div", {
            className: "video-block__inner",
            children: /*#__PURE__*/ _jsx(VideoBlock, {
                ...p.media.media
            })
        })
    }) : /*#__PURE__*/ _jsx(_Fragment, {});
    return /*#__PURE__*/ _jsx(Block, {
        children: /*#__PURE__*/ _jsx("div", {
            className: `richtext-block ${classNames.block} ${p.media != "none" ? ' richtext-block--media' : ' richtext-block--plain'}`,
            children: /*#__PURE__*/ _jsxs("div", {
                className: `richtext-block__media-container ${innerClass} ${p.media != "none" ? p.media.position : ""} `,
                children: [
                    p.media != "none" && /*#__PURE__*/ _jsx("div", {
                        className: `richtext-block__media richtext-block__media--${p.media.position}`,
                        children: media
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: `richtext-block__container-buttons`,
                        children: [
                            p.title && /*#__PURE__*/ _jsx("h2", {
                                "data-anchor": slugify(p.title),
                                className: "richtext-block__title title--l",
                                children: p.title
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                dangerouslySetInnerHTML: {
                                    __html: p.html
                                },
                                className: "richtext-block__container text--styled"
                            }),
                            (p.primaryActionTitle != "" || p.secondaryActionTitle != "") && /*#__PURE__*/ _jsxs("div", {
                                className: "richtext-block__buttons",
                                children: [
                                    p.primaryActionTitle != "" && /*#__PURE__*/ _jsx("a", {
                                        className: "button button--primary button--arrow",
                                        href: p.primaryActionUrl,
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "button__label",
                                            children: p.primaryActionTitle
                                        })
                                    }),
                                    p.secondaryActionTitle != "" && /*#__PURE__*/ _jsx("a", {
                                        className: "button button--secondary",
                                        href: p.secondaryActionUrl,
                                        children: /*#__PURE__*/ _jsx("span", {
                                            className: "button__label",
                                            children: p.secondaryActionTitle
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
{}